import { render, staticRenderFns } from "./HKInfo.vue?vue&type=template&id=030f8295&scoped=true"
import script from "./HKInfo.vue?vue&type=script&lang=js"
export * from "./HKInfo.vue?vue&type=script&lang=js"
import style0 from "./HKInfo.vue?vue&type=style&index=0&id=030f8295&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030f8295",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('030f8295')) {
      api.createRecord('030f8295', component.options)
    } else {
      api.reload('030f8295', component.options)
    }
    module.hot.accept("./HKInfo.vue?vue&type=template&id=030f8295&scoped=true", function () {
      api.rerender('030f8295', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/IdentityKYC/components/HKInfo.vue"
export default component.exports